import React from 'react';
import ReactDOM from 'react-dom/client';
import { render } from "react-dom";
import { BrowserRouter, Route, Link, Routes, Switch, HashRouter} from 'react-router-dom';

import './index.css';
import Home from './Layout/Pages/Home';
import Serial from './Layout/Pages/Verify/Serial';
import Serialnumber from './Layout/Pages/Verify/Serialnumber';
import Serialnumbergenuine from './Layout/Pages/Verify/Serialnumbergenuine';
import reportWebVitals from './reportWebVitals';
import Serialgp10 from './Layout/Pages/gp10/Serialgp10';
import Serialnumbergp10 from './Layout/Pages/gp10/Serialnumbergp10';
import Serialnumbergenuinegp10 from './Layout/Pages/gp10/Serialnumbergenuinegp10';
import Homeg10 from './Layout/Pages/gp10/Homeg10';
import Nodata from './Layout/Pages/gp10/Nodata';
import Pureghee900ml from './Layout/Pages/pureghee900ml/Pureghee900ml';
import Pureghee450ml from './Layout/Pages/Verify/Pureghee450ml';
import Cowghee from './Layout/Pages/Verify/Cowghee';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
      <Routes>
          <Route path="/" element={<Home />} />

          
          <Route path="/:qrCode" element={<Serial />} /> 
          <Route path="/serial" element={<Serialnumber />} /> 
          <Route path="/not-found/" element={<Serialnumbergenuine />} /> 
          
          <Route path="/gp10/" element={<Homeg10 />} /> 
          <Route path="/gp10/:qrCode" element={<Serialgp10 />} />        
          <Route path="/gp10/not-found/:qrCode" element={<Serialnumbergenuinegp10 />} /> 
          <Route path="/gp10/invalid-coupon-code/" element={<Nodata />} /> 


          <Route path="/mt-pure-ghee-900ml" element={<Home />} />
          <Route path="/mt-pure-ghee-900ml/:qrCode" element={<Pureghee900ml />} /> 
          <Route path="/mt-pure-ghee-900ml/invalid-coupon-code" element={<Nodata />} /> 
        

          <Route path="/pure-ghee-450ml" element={<Home />} />
          <Route path="/pure-ghee-450ml/:qrCode" element={<Pureghee450ml />} /> 
          <Route path="/pure-ghee-450ml/invalid-coupon-code" element={<Nodata />} /> 

          

          <Route path="/cow-ghee" element={<Home />} />
          <Route path="/cow-ghee/:qrCode" element={<Cowghee />} /> 
          <Route path="/cow-ghee/invalid-coupon-code" element={<Nodata />} /> 

      </Routes>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
